module.exports = __webpack_public_path__ + "static/media/question-mark_16.e11cd050.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/icons/lib/question-mark_16.svg
// module id = 894
// module chunks = 0